import {
  Tooltip
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';

const ChipTooltip = withStyles((theme) => ({
  tooltip: {
    color: '#fcfcfc',
    background: '#1C1D21B7',
    opacity: 1,
    width: 350,
    maxWidth: 450,
    fontSize: theme.typography.pxToRem(11),
    border: '1px solid #dadde9',
    margin: '0px 0px 0px 20px'
  }
}))(Tooltip);

export default ChipTooltip

